import { Avatar, IconButton } from '@mui/material';
import styled from '@mui/material/styles/styled';

export const UserBoxButton = styled(IconButton)(() => ({
    padding: 0,
    height: 50,
    width: 50,
}));

export const UserBoxAvatar = styled(Avatar)(({ theme }) => ({
    height: '100%',
    width: '100%',
    backgroundColor: theme.palette.primary.dark,
    borderWidth: 3,
    borderStyle: 'solid',
    borderColor: theme.palette.primary.light,
}));
